import { FieldConfig, FieldDataTypes, ModelInterface, Uuid } from '@hidat/huijs-common';
import { HasTenantResource, NestUpdateTrackingResource, ResourceConfig } from '@hidat/huijs-resource';
import { ZonedDateTime } from '@js-joda/core';
import { splixerFieldConfigs, splixerSystemFields } from './splixer-fields.const';
import { EmailTypes } from './splixer-types';

export const EmailLinkConfig: ResourceConfig = new ResourceConfig(
  'ListenerLink',
  'listener_links',
  true,
  true,
)
  .addFields(splixerSystemFields)
  .addFields([
    splixerFieldConfigs.tenantId,
    splixerFieldConfigs.stationId,
    new FieldConfig('listenerId', FieldDataTypes.UID),
    new FieldConfig('linkType'),
    new FieldConfig('linkCode'),
    new FieldConfig('confirmationCode'),
    new FieldConfig('expiresAt', FieldDataTypes.DATEZONED),
    new FieldConfig('usedAt', FieldDataTypes.DATEZONED),
  ]);

/**
 * Magic-links sent on behalf of the listener
 */
export interface EmailLinkInterface
  extends ModelInterface, NestUpdateTrackingResource, HasTenantResource {
  email: string | undefined;
  name: string | undefined;
  emailType: EmailTypes | undefined;
  listenerId: Uuid | undefined;
  tenantId: Uuid | undefined;
  stationId: number | undefined;
  instanceId: number | undefined;
  linkCode: string | undefined;
  confirmationCode: string | undefined;
  maxUsages: number | undefined;
  usageCount: number | undefined;
  expiresAt: ZonedDateTime | undefined;
  usedAt: ZonedDateTime | undefined;
}
